import Divider from '@mui/material/Divider';
import MuiTabs from '@mui/material/Tabs';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useLocation, useResolvedPath } from 'react-router-dom';
import classes from './Tabs.module.scss';

export default function Tabs({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { pathname } = useLocation();
  const parentRoute = useResolvedPath('');
  const subPath = pathname.replace(parentRoute.pathname, '').replace(/^\//, '');

  return (
    <div className={clsx(className, classes.root)}>
      <MuiTabs indicatorColor="secondary" textColor="primary" value={subPath}>
        {children}
      </MuiTabs>
      <Divider className={classes.divider} />
    </div>
  );
}
